import { createContext } from "react";

export const DeliveryContext = createContext();
